export const CreatecaseTemplateFormSteps = [
  {
    target: "#Header",
    content:
      "Set the template name and choose the associated practice area for this case template.",
  },
  {
    target: "#template_name",
    content:
      "Enter a meaningful name to easily identify this case template later.",
  },
  {
    target: "#selet_practice_area",
    content:
      "Select the practice area where this template will be used when creating matters.",
  },
  {
    target: "#close_template_form",
    content:
      "Click here to close and exit the template editor without saving changes.",
  },
  {
    target: "#drag_section",
    content:
      "Drag a new section from here to create a blank section in the form layout.",
  },
  {
    target: "#custom_field_picker",
    content:
      "Choose a field type from this list and drag it into any section in your form.",
    placement: "left",
  },
  {
    target: "#Un_used_field_picker",
    content:
      "Removed fields will appear here. You can drag them back into the form anytime.",
  },
  {
    target: "#preview_save_btn",
    content:
      "Click here to preview your template or save it when you're done editing.",
  },
  {
    target: "#drop_section_area",
    content:
      "This is the main workspace. Drop sections here to start building your form.",
    // placement: "center",
  },
  {
    target: "#section_box",
    content:
      "This is where fields are added. Drag and drop fields into this section from the sidebar.",
  },
  {
    target: "#section_name",
    content:
      "Provide a title for this section to organize fields by category or topic.",
  },
  {
    target: "#field_box",
    content:
      "Each draggable field appears here. You can rearrange fields or move them between sections.",
  },
  {
    target: "#field_name",
    content:
      "Set the label for this field — this will be shown in the final form.",
  },
];
